import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PLANEJAMENTO_VIAGEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('planejamentoViagem', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/planejamentoViagem`);
    return {
        type: 'PLANEJAMENTO_VIAGEM_LISTADO',
        payload: request
    };
}
export function salvar(registro) {
    return (dispatch, getState) => {
		console.log({
			...registro
		});
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/planejamentoViagem`, {
				...registro

			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/planejamentoViagem`, {
				...registro

			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/planejamentoViagem?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function imprimir(registro) {

	return (dispatch, getState) => {

		axios.post(`${consts.API_URL}/planejamentoViagem/gerarPdf`, registro)
		.then(resp => {
			window.open(`https://api-engel.infinitum-ti.com/${resp.data}`, '_blank');
		}).catch(ex => {
			console.log(ex);
		});

	}

}
